import { ROUTES } from '@dashboard/router/routeNames'
import { useConfigStore } from '@dashboard/stores/configStore'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

/** Pages is on every plan; only the public demo, which serves no hosted API, goes without it. */
export function useHostedPagesAccess() {
  const { currentTeamPid } = storeToRefs(useConfigStore())
  return computed(() => currentTeamPid.value !== 'demo')
}

/** Route guard for every Pages route: the demo gets the not-found page at the same URL. */
export function requireHostedPages(to: RouteLocationNormalized): RouteLocationRaw | true {
  if (Number.isInteger(Number(to.params.teamPid))) {
    return true
  }
  return {
    name: ROUTES.NOTFOUNDAUTH,
    params: { teamPid: String(to.params.teamPid), pathMatch: to.path.split('/').filter(Boolean).slice(1) },
    query: to.query,
    hash: to.hash
  }
}
